import { styled } from '@mui/material/styles';
import { Table } from 'shared/mui/Table';

export const TableStyled = styled(Table)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  '& .MuiTableCell-root': {
    verticalAlign: 'middle',
    height: 56,
    padding: '0 16px',
  },
  '& .MuiTableCell-head': {
    lineHeight: '18px',
  },
  '& .cell-id': {
    width: '48px',
    minWidth: '48px',
    maxWidth: '48px',
  },
  '& .cell-name': {
    width: '156px',
    minWidth: '156px',
    maxWidth: '156px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .cell-total': {
    width: '112px',
    minWidth: '112px',
    maxWidth: '112px',
    textAlign: 'right',
  },
  '& .cell-success': {
    width: '190px',
    minWidth: '190px',
    maxWidth: '190px',
    textAlign: 'right',
  },
}));
